import { useCallback, useMemo } from 'react';
import { OptionsObject } from 'components';
import { Criterion } from 'queries';
import { ActionMeta } from 'react-select';

type OnChangeCb = (
  values?: OptionsObject | OptionsObject[] | undefined,
  meta?: ActionMeta<OptionsObject>,
) => void;

export const useMultiSelectToCriterion = (
  criterion: Criterion,
  onChange: (c: Criterion) => any,
): [(string | number)[], OnChangeCb] => {
  const _onChange: OnChangeCb = useCallback(
    (values, meta) => {
      if (
        !values ||
        !Array.isArray(values) ||
        !values.length ||
        (meta && meta.action === 'clear')
      ) {
        onChange({
          ...criterion,
          allowList: null,
        });
        return;
      }

      onChange({
        ...criterion,
        allowList: values.map(({ value }) => value),
      });
    },
    [onChange, criterion],
  );

  const value = useMemo(() => {
    if (!criterion?.allowList?.length) {
      return [];
    }
    return criterion.allowList as string[] | number[];
  }, [criterion]);

  return [value, _onChange];
};
